import { useEffect, useState } from 'react';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';
import { useRouter } from 'next/router';
import getEnrollmentCodeStatus from '@/api/enrollment/getEnrollmentCodeStatus.endpoint';
import { notification } from 'antd';

export default function useCheckEnrollmentCodeStep({ flowActions }) {
  const router = useRouter();
  const [state, setState] = useState({
    loading: true,
    showForm: false,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    checkEnrollmentCode: async (enrollmentCode, redirect) => {
      actions.setState({
        loading: true,
      });
      try {
        const response = await getEnrollmentCodeStatus(enrollmentCode);
        if (response.status == 'valid') {
          actions.setState({
            loading: false,
          });
          flowActions.setClass(response.class);
          flowActions.setActiveStep('createAndEnrollStudent');
        } else {
          if (redirect) {
            router.push('/student/enrollment');
          } else {
            actions.setState({
              loading: false,
            });
            notification.error({
              message: 'Enrollment code error',
              description: `The enrollment code is invalid. Try with another one`,
            });
          }
        }
      } catch (error) {
        console.error(error);
        actions.setState({
          loading: false,
        });
        openAPIErrorNotification({
          title: 'There was an error',
          description: 'There was a problem with your enrollment code.',
          errorFeedback: error.feedbackData,
        });
      }
    },
  };

  useEffect(() => {
    if (router.isReady) {
      if (router.query.enrollmentCode) {
        actions.checkEnrollmentCode(router.query.enrollmentCode, true);
      } else {
        actions.setState({
          showForm: true,
          loading: false,
        });
      }
    }
  }, [router.isReady]);

  return { state, actions };
}
